import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import React, { useState } from 'react'
import { BaseTextField } from 'src/components/common'
import { useFormik } from 'formik';
import * as yup from 'yup';
import { validationRules } from 'src/utils/validation/validationRules';

const expertFieldValidationSchema = yup.object().shape({
  companyName: validationRules.requiredDefaultStringRule,
  title: validationRules.requiredDefaultStringRule,
  phone: validationRules.PHONE_NUMBER,
});


export const ExpertFields:React.FC<any> = (props) => {
  const {open, onSubmit} = props;

  const formik = useFormik({
    initialValues: {
      companyName: '',
      title: '',
      phone: ''
    },
    validationSchema: expertFieldValidationSchema,
    validateOnChange: false,
    onSubmit: (values) => {
      onSubmit(values);
      formik.setErrors({});
    },
  });

  return (
    <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{ style: {maxWidth: '600px', width: '100%'} }}
      >
        <DialogTitle id="customized-dialog-title">
          Register as an Expert : Step 1
        </DialogTitle>
        <DialogContent dividers>
          <form onSubmit={formik.handleSubmit}>
            <BaseTextField
              label="Company Name"
              name="companyName"
              style={{marginBottom: '20px'}}
              value={formik.values.companyName}
              onChange={formik.handleChange}
              errorText={formik.errors.companyName}
            />
            <BaseTextField
              label="Title"
              name="title"
              style={{marginBottom: '20px'}}
              value={formik.values.title}
              onChange={formik.handleChange}
              errorText={formik.errors.title}
            />
            <BaseTextField
              label="Phone Number"
              name="phone"
              style={{marginBottom: '20px'}}
              value={formik.values.phone}
              onChange={formik.handleChange}
              errorText={formik.errors.phone}
            />
            <Button
              autoFocus
              type='submit' 
              color="primary"
              variant='contained'
              fullWidth
            >
              Continue
            </Button>
          </form>
        </DialogContent>
      </Dialog>
  )
}
